import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../login/services/auth.service';
import { SitesBuilderService } from '../services/sites-builder.service';

@Injectable({
  providedIn: 'root',
})
export class S3InfoResolver {
  constructor(
    private sitesBuilderService: SitesBuilderService,
    private authService: AuthService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.sitesBuilderService.getS3Info$(route.params['site']).pipe(
      map((info) => {
        if (!info.mapConfig.enabled) {
          this.router.navigate(['/notfound']);
          return null;
        }

        if (info.toolsConfig.credential.enabled) {
          const invalidToken = this.authService.isTokenExpired(route.params['site']);
          localStorage.removeItem('view_id');
          if (route.queryParams.view_id) {
            localStorage.setItem('view_id', route.queryParams.view_id);
          }
          if (invalidToken) {
            this.router.navigate([`/${route.params['site']}/login`]);
            return null;
          }
        }

        return info;
      }),
      catchError((error) => {
        console.log(error);
        this.router.navigate(['/notfound']);
        return of({ error: error });
      })
    );
  }
}
